import { render, staticRenderFns } from "./affiliations_dashboard.vue?vue&type=template&id=353f1c0a&scoped=true&"
import script from "./affiliations_dashboard.vue?vue&type=script&lang=js&"
export * from "./affiliations_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f1c0a",
  null
  
)

export default component.exports